import { createGlobalStyle } from 'styled-components';
import margins from './margins.styled';
import flex from './flex.styled';

const GlobalStyles = createGlobalStyle`
html {
  font-size: 16px;
  overflow-x: overlay; /* so the horizontal scrollbar doesn't enable vertical scrollbar */
  --read-only-opacity: 45%;
}

body {
  font-family: ${({ theme }) => theme.fonts.regular};
  color: ${({ theme }) => theme.colors.primaryText};
  background-color: ${({ theme }) => theme.colors.primaryBackground};
}

.modal-md {
  width: 620px;
  max-width: none;
}

.modal-content {
  border-radius: 10px;
}

.modal-lg {
  width: 920px;
  max-width: none;
}

.modal {
  z-index: 10500;
}

.disabled{
  filter: opacity(0.5) !important;
  cursor: not-allowed !important;
}

.inactive{
  filter: opacity(0.5);
}

.hoverable:hover {
  cursor: pointer;
  filter: opacity(0.75);
}

.hoverable--darker:hover {
  cursor: pointer;
  filter: brightness(0.7);
}

.hoverable--dark:hover {
  cursor: pointer;
  filter: brightness(0.95);
}

// stops tooltip from expanding screen on fade in
.tooltip {
  inset: 0px auto auto 0px;
  font-family: ${({ theme }) => theme.fonts.regular} !important;;
}

.k-animation-container-shown, .k-animation-container {
  z-index: 10500 !important;
}

.k-checkbox {
  border: 1px solid ${({ theme }) => theme.colors.checkboxOutline};

  &:hover {
    filter: brightness(0.7);
  }

  &:checked {
    border: none;
    background: ${({ theme }) => theme.colors.primary};
  }

  &:checked:after {
    content: url(${process.env.PUBLIC_URL}/assets/images/checkmark.png);
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.secondaryText};
    outline-offset: 0;
  }
}


  .k-calendar-view {
    z-index: 3;
  }

  .no-pointer-events {
    pointer-events: none;
  }

  .ml__kendo-grid {
    flex: 1;
    min-width: 0;
    height: 100%;
    border: none;
    border-top-left-radius: 8px;
    background-color: ${({ theme }) => theme.colors.quaternaryBackground};

    :not(.ignore-styles) {
      font-size: 12.5px;
      font-weight: normal;
      font-family: ${({ theme }) => theme.fonts.regular} !important;
      color: ${({ theme }) => theme.colors.quinaryText};
    }

    .k-widget {
      border: none;
      background-color: transparent;
    }

    .k-grid-draggable-header {
      align-items: center;
      border: none;
      background-color: transparent;
    }

    .k-grid-header-wrap {
      border: none;
    }

    table:hover {
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
    }

    thead th:hover * {
      font-weight: 600;
    }

    th.k-header .k-grid-filter {
      width: 25px;
      height: 25px;

      margin-bottom: 8px;
      padding-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    th.k-header .k-grid-filter .k-icon {
      font-size: 12.5px !important;
    }

    .k-icon {
      font-family: 'WebComponentsIcons' !important;
    }

    th.k-header.active .k-grid-filter {
      border-radius: 5px;
      background-color: ${({ theme }) => theme.colors.primary};
    }

    th input[type='checkbox'] {
      position: relative;
      top: 3px;
    }

    td input[type='checkbox'] {
      position: relative;
      top: 6px;
    }

    td{
      vertical-align: top;
    }

    .k-grid-container {
      border-radius: 4px;
    }

    .k-grid-content {
      background-color: ${({ theme }) => theme.colors.secondaryBackground};
    }

    .k-master-row.k-alt {
      background-color: ${({ theme }) => theme.colors.gridAltRow};
    }

    .k-pager-numbers .k-link.k-selected {
      color: #00bcd4;
      background-color: rgba(0, 188, 212, 0.22);
    }

    .k-pager-sizes .k-dropdown-list,
    .k-pager-sizes .k-dropdown,
    .k-pager-sizes .k-dropdownlist,
    .k-pager-sizes > select {
      width: 100%;
    }

    .k-detail-row .k-hierarchy-cell {
      background: ${({ theme }) => theme.colors.quaternaryBackground};
      border-bottom: 0;
    }
  }

  .k-actions {
    flex-direction: row-reverse;

    &.k-hstack {
      flex-direction: row;
    }
  }

  // utility classes
  ${margins};
  ${flex};
`;

export default GlobalStyles;
